// // import React, { createContext, useContext, useState, useEffect } from 'react';
// // import { onAuthStateChanged, signInWithPopup, signOut as firebaseSignOut } from 'firebase/auth';
// // import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
// // import { auth, googleProvider, db } from '../firebase';
// // import { Box, Spinner, Center } from '@chakra-ui/react';
import { resolveStoreContext } from '../utils/storeResolver';

// // const AuthContext = createContext();

// // export const useAuth = () => useContext(AuthContext);

// // export const AuthProvider = ({ children }) => {
// //   const [currentUser, setCurrentUser] = useState(null);
// //   const [userData, setUserData] = useState(null); // State to hold user data from Firestore
// //   const [loading, setLoading] = useState(true);

// //   // Function to create or update user profile in Firestore
// //   const createUserProfileDocument = async (userAuth, additionalData = {}) => {
// //     if (!userAuth) return;

// //     const userRef = doc(db, 'users', userAuth.uid);
// //     const userSnapshot = await getDoc(userRef);

// //     if (!userSnapshot.exists()) {
// //       // User is new, create the document
// //       const { displayName, email, photoURL } = userAuth;
// //       const createdAt = serverTimestamp(); // Use server timestamp for creation date
// //       const userType = "buyer"; // Set user type

// //       try {
// //         await setDoc(userRef, {
// //           displayName,
// //           email,
// //           photoURL,
// //           createdAt,
// //           userType,
// //           ...additionalData, // Merge any additional data if needed
// //         });
// //         console.log("New user profile created in Firestore.");
// //         // Fetch the newly created data to update context state
// //         const newUserSnap = await getDoc(userRef);
// //         setUserData(newUserSnap.data());
// //       } catch (error) {
// //         console.error("Error creating user profile:", error);
// //       }
// //     } else {
// //        // User exists, fetch their data
// //        console.log("Existing user found, fetching profile.");
// //        setUserData(userSnapshot.data());
// //     }
// //   };

// //   // Google Sign-In Function
// //   const signInWithGoogle = async () => {
// //     try {
// //       const result = await signInWithPopup(auth, googleProvider);
// //       // No need to manually call createUserProfileDocument here,
// //       // the onAuthStateChanged listener below will handle it.
// //       console.log("Google Sign-In successful:", result.user.uid);
// //       return result.user; // Return user object on success
// //     } catch (error) {
// //       console.error("Google Sign-In Error:", error.code, error.message);
// //       // Handle specific errors if needed (e.g., popup closed)
// //       return null; // Indicate failure
// //     }
// //   };

// //   // Sign Out Function
// //   const signOut = async () => {
// //     try {
// //       await firebaseSignOut(auth);
// //       setCurrentUser(null);
// //       setUserData(null); // Clear user data on sign out
// //     } catch (error) {
// //       console.error("Sign Out Error:", error);
// //     }
// //   };

// //   useEffect(() => {
// //     // Listen for authentication state changes
// //     const unsubscribe = onAuthStateChanged(auth, async (userAuth) => {
// //       if (userAuth) {
// //         // User is signed in
// //         setCurrentUser(userAuth);
// //         // Create/fetch user profile from Firestore
// //         await createUserProfileDocument(userAuth);
// //       } else {
// //         // User is signed out
// //         setCurrentUser(null);
// //         setUserData(null);
// //       }
// //       setLoading(false);
// //     });

// //     // Cleanup subscription on unmount
// //     return unsubscribe;
// //   }, []); // Empty dependency array ensures this runs only once on mount

// //   const value = {
// //     currentUser,
// //     userData, // Expose Firestore user data
// //     signInWithGoogle,
// //     signOut, // Expose sign out function
// //   };

// //   if (loading) {
// //     return (
// //       <Center height="100vh">
// //         <Spinner size="xl" />
// //       </Center>
// //     );
// //   }

// //   return (
// //     <AuthContext.Provider value={value}>
// //       {children}
// //     </AuthContext.Provider>
// //   );
// // };



// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { 
//   onAuthStateChanged, 
//   signInWithPopup, 
//   signOut as firebaseSignOut,
//   createUserWithEmailAndPassword,
//   signInWithEmailAndPassword,
//   deleteUser
// } from 'firebase/auth';
// import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
// import { auth, googleProvider, db } from '../firebase';
// import { Spinner, Center } from '@chakra-ui/react';

// const AuthContext = createContext();

// export const useAuth = () => useContext(AuthContext);

// export const AuthProvider = ({ children }) => {
//   const [currentUser, setCurrentUser] = useState(null);
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // --- 1. REGISTER (New Users) ---
//   const registerWithEmail = async (email, password, details) => {
//     // 1. Create Auth Account
//     const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//     const user = userCredential.user;

//     // 2. Create Profile in Firestore with 'pending' status
//     const userRef = doc(db, 'users', user.uid);
//     await setDoc(userRef, {
//       uid: user.uid,
//       email: user.email,
//       displayName: details.name,
//       phoneNumber: details.phone,
//       gstPan: details.gstPan,
//       userType: 'buyer',
//       status: 'pending', // Vital for approval logic
//       createdAt: serverTimestamp(),
//     });

//     // 3. Sign out immediately so they can't access protected routes yet
//     await firebaseSignOut(auth);
//     return true;
//   };

//   // --- 2. LOGIN (Email/Password) ---
//   const loginWithEmail = async (email, password) => {
//     const userCredential = await signInWithEmailAndPassword(auth, email, password);
//     const user = userCredential.user;

//     // Check Firestore Profile
//     const userRef = doc(db, 'users', user.uid);
//     const userSnap = await getDoc(userRef);

//     if (!userSnap.exists()) {
//       await firebaseSignOut(auth);
//       throw new Error("User profile not found. Please register.");
//     }

//     const data = userSnap.data();
//     if (data.status === 'pending') {
//       await firebaseSignOut(auth);
//       throw new Error("Account is awaiting admin approval.");
//     }
//     if (data.status === 'rejected') {
//       await firebaseSignOut(auth);
//       throw new Error("Account has been rejected. Contact support.");
//     }

//     // If approved, state will update via onAuthStateChanged
//     return user;
//   };

//   // --- 3. LOGIN (Google - Restricted to Existing Users) ---
//   const signInWithGoogle = async () => {
//     try {
//       const result = await signInWithPopup(auth, googleProvider);
//       const user = result.user;

//       // Check if user exists in Firestore
//       const userRef = doc(db, 'users', user.uid);
//       const userSnap = await getDoc(userRef);

//       if (!userSnap.exists()) {
//         // CRITICAL: Block new users attempting to use Google Sign In without registration
//         // Delete the auth record to keep things clean (optional but recommended)
//         await deleteUser(user); 
//         throw new Error("Account not found. Please register as a new user first.");
//       }

//       const data = userSnap.data();

//       if (data.status === 'pending') {
//         await firebaseSignOut(auth);
//         throw new Error("Account is awaiting admin approval.");
//       }
//       if (data.status === 'rejected') {
//         await firebaseSignOut(auth);
//         throw new Error("Account has been rejected.");
//       }

//       return user;
//     } catch (error) {
//       console.error("Google Sign-In Error:", error.message);
//       throw error; // Re-throw to be caught in UI
//     }
//   };

//   // --- 4. SIGN OUT ---
//   const signOut = async () => {
//     try {
//       await firebaseSignOut(auth);
//       setCurrentUser(null);
//       setUserData(null);
//     } catch (error) {
//       console.error("Sign Out Error:", error);
//     }
//   };

//   // --- 5. AUTH LISTENER ---
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (userAuth) => {
//       if (userAuth) {
//         // Fetch user data whenever auth state is detected
//         try {
//           const userRef = doc(db, 'users', userAuth.uid);
//           const userSnap = await getDoc(userRef);

//           if (userSnap.exists()) {
//             const data = userSnap.data();
//             setUserData(data);
//             // If somehow a pending/rejected user is logged in (e.g. status changed while active), 
//             // we let ProtectedRoute handle the blocking, or sign them out here.
//             // For UX, we set currentUser so ProtectedRoute can see the status.
//             setCurrentUser(userAuth);
//           } else {
//             // Auth exists but no Firestore doc? Should treat as logged out or unverified.
//             setUserData(null);
//             setCurrentUser(userAuth);
//           }
//         } catch (err) {
//           console.error("Error fetching user profile:", err);
//           setUserData(null);
//         }
//       } else {
//         setCurrentUser(null);
//         setUserData(null);
//       }
//       setLoading(false);
//     });

//     return unsubscribe;
//   }, []);

//   const value = {
//     currentUser,
//     userData,
//     registerWithEmail,
//     loginWithEmail,
//     signInWithGoogle,
//     signOut,
//   };

//   if (loading) {
//     return (
//       <Center height="100vh">
//         <Spinner size="xl" color="teal.500" />
//       </Center>
//     );
//   }

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };


import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  onAuthStateChanged,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut as firebaseSignOut
} from 'firebase/auth';
import { doc, getDoc, setDoc, serverTimestamp, collection, query, where, getDocs, addDoc, limit, runTransaction } from 'firebase/firestore';
import { auth, googleProvider, db } from '../firebase';
import { Spinner, Center } from '@chakra-ui/react';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// Helper to extract subdomain (only returns subdomain handle)
const getSubdomain = () => {
  const context = resolveStoreContext();
  return (context.type === 'subdomain') ? context.handle : null;
};

// Helper to extract hostname when visiting via custom domain
const getHostDomain = () => {
  const context = resolveStoreContext();
  return (context.type === 'customDomain') ? context.domain : null;
};

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null); // Stores Firestore profile data + specific store status
  const [loading, setLoading] = useState(true);
  const [storeConfig, setStoreConfig] = useState(null);
  const [storeConfigLoaded, setStoreConfigLoaded] = useState(false);
  const [buyerPoints, setBuyerPoints] = useState(null);
  const [selectedRedeemReward, setSelectedRedeemReward] = useState(null);

  // --- 0. FETCH STORE CONFIG (Public/Private Mode) ---
  useEffect(() => {
    const fetchStoreConfig = async () => {
      // Resolve either by subdomain or by custom domain lookup
      const subdomain = getSubdomain();
      const hostDomain = getHostDomain();
      const usersRef = collection(db, 'users');
      try {
        if (subdomain) {
          const q = query(usersRef, where('storeHandle', '==', subdomain.toLowerCase()));
          const snap = await getDocs(q);
          if (!snap.empty) {
            setStoreConfig({ uid: snap.docs[0].id, ...snap.docs[0].data() });

            // --- ANALYTICS: Track Unique Daily Visit ---
            const visitKey = `visited_${subdomain}_${new Date().toISOString().split('T')[0]}`;
            if (!sessionStorage.getItem(visitKey)) {
              axios.post(`${API_BASE_URL}/api/analytics/visit`, { storeHandle: subdomain })
                .catch(err => console.error("Analytics visit ping failed:", err));
              sessionStorage.setItem(visitKey, 'true');
            }
          }
        } else if (hostDomain) {
          // Lookup by customDomain field in users collection
          const q = query(usersRef, where('customDomain', '==', hostDomain.toLowerCase()));
          const snap = await getDocs(q);
          if (!snap.empty) {
            const data = snap.docs[0].data();
            // Ensure storeConfig contains storeHandle for downstream logic
            setStoreConfig({ uid: snap.docs[0].id, ...data });

            // Analytics: use resolved storeHandle if available
            const resolvedHandle = (data.storeHandle || hostDomain).toLowerCase();
            const visitKey = `visited_${resolvedHandle}_${new Date().toISOString().split('T')[0]}`;
            if (!sessionStorage.getItem(visitKey)) {
              axios.post(`${API_BASE_URL}/api/analytics/visit`, { storeHandle: resolvedHandle })
                .catch(err => console.error("Analytics visit ping failed:", err));
              sessionStorage.setItem(visitKey, 'true');
            }
          }
        }
      } catch (error) {
        console.error("Error fetching store config:", error);
      }
      setStoreConfigLoaded(true);
    };
    fetchStoreConfig();
  }, []);

  // --- 1. GOOGLE AUTH (Raw) ---
  // Just handles the popup. Logic for what to do next is in the UI.
  const googleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      return result.user;
    } catch (error) {
      console.error("Google Auth Error:", error);
      throw error;
    }
  };

  // --- 1.1 EMAIL AUTH (Raw) ---
  const emailLogin = async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error) {
      console.error("Email Login Error:", error);
      throw error;
    }
  };

  const emailSignup = async (email, password) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error) {
      console.error("Email Signup Error:", error);
      throw error;
    }
  };

  const resetPassword = async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
    } catch (error) {
      console.error("Password Reset Error:", error);
      throw error;
    }
  };

  // --- 2. CHECK PROFILE STATUS ---
  // Helper to check if a profile exists and get its data, including store-specific request status
  const getUserProfile = async (uid) => {
    const docRef = doc(db, 'users', uid);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) return null;

    let profile = docSnap.data();
    const subdomain = getSubdomain();

    // If the user is browsing a specific store, fetch their access request for that store
    if (subdomain) {
      const accessReqRef = doc(db, 'store_access_requests', `${uid}_${subdomain}`);
      const accessReqSnap = await getDoc(accessReqRef);
      if (accessReqSnap.exists()) {
        profile.status = accessReqSnap.data().status;
      } else {
        profile.status = undefined; // Need to request access
      }
    }

    return profile;
  };

  // --- 3. SAVE NEW PROFILE & REQUEST ACCESS ---
  const saveUserProfile = async (uid, details) => {
    const userRef = doc(db, 'users', uid);

    // 1. Save global user profile (base identity)
    await setDoc(userRef, {
      uid: uid,
      email: details.email,
      displayName: details.name,
      photoURL: details.photoURL || '',
      phoneNumber: details.phone,
      gstPan: details.gstPan,
      businessName: details.businessName || '',
      address: details.address || '',
      cardPhotoUrl: details.cardPhotoUrl || '',
      userType: 'buyer',
      createdAt: serverTimestamp(),
    }, { merge: true });

    // 2. Request store access if on a subdomain
    const subdomain = getSubdomain();
    if (subdomain) {
      const accessReqRef = doc(db, 'store_access_requests', `${uid}_${subdomain}`);
      await setDoc(accessReqRef, {
        buyerUid: uid,
        storeHandle: subdomain,
        status: 'pending',
        buyerName: details.name,
        buyerEmail: details.email,
        buyerPhone: details.phone,
        buyerGst: details.gstPan,
        buyerBusinessName: details.businessName || '',
        buyerAddress: details.address || '',
        buyerCardPhotoUrl: details.cardPhotoUrl || '',
        createdAt: serverTimestamp(),
      });
    }

    // Fire and forget. We don't wait for the result.
    axios.post(`${API_BASE_URL}/api/notify-signup`, {
      userName: details.name,
      userEmail: details.email,
      storeHandle: subdomain || '' // Pass the store context for targeted notifications
    }).catch(err => console.error("Background notification error:", err));

    // Reload the full profile context
    const updatedProfile = await getUserProfile(uid);
    setUserData(updatedProfile);
  };

  // --- 3.5. UPDATE PROFILE (Merge) ---
  const updateUserProfile = async (uid, updates) => {
    const userRef = doc(db, 'users', uid);
    // updates typically { displayName, phoneNumber, gstPan }
    // If critical fields change, we MIGHT want to reset status to pending.
    // For now, let's keep it simple: just update fields.
    await setDoc(userRef, updates, { merge: true });

    // Refresh local
    const snap = await getDoc(userRef);
    setUserData(snap.data());
  };

  // --- 4. SIGN OUT ---
  const signOut = async () => {
    try {
      const subdomain = getSubdomain() || 'default';
      const uid = currentUser?.uid || 'guest';
      const rewardKey = `selected_redeem_reward_${subdomain}_${uid}`;
      localStorage.removeItem(rewardKey);
      await firebaseSignOut(auth);
      setCurrentUser(null);
      setUserData(null);
      setSelectedRedeemReward(null);
    } catch (error) {
      console.error("Sign Out Error:", error);
    }
  };

  const selectRedeemReward = (reward) => {
    setSelectedRedeemReward(reward || null);
    try {
      const subdomain = getSubdomain() || 'default';
      const uid = currentUser?.uid || 'guest';
      const rewardKey = `selected_redeem_reward_${subdomain}_${uid}`;
      if (reward) {
        localStorage.setItem(rewardKey, JSON.stringify(reward));
      } else {
        localStorage.removeItem(rewardKey);
      }
    } catch (err) {
      console.error('Failed to persist selected reward:', err);
    }
  };

  const clearRedeemReward = () => {
    setSelectedRedeemReward(null);
    try {
      const subdomain = getSubdomain() || 'default';
      const uid = currentUser?.uid || 'guest';
      const rewardKey = `selected_redeem_reward_${subdomain}_${uid}`;
      localStorage.removeItem(rewardKey);
    } catch (err) {
      console.error('Failed to clear selected reward:', err);
    }
  };

  const createCustomRewardClaim = async (reward) => {
    if (!currentUser) throw new Error('Please sign in to claim rewards.');

    const subdomain = getSubdomain();
    if (!subdomain) throw new Error('Store context missing. Please open a store URL.');

    const pointsRequired = Number(reward?.pointsCost || 0);
    if (pointsRequired <= 0) throw new Error('Invalid reward points requirement.');

    const pendingClaimsQuery = query(
      collection(db, 'reward_claim_requests'),
      where('buyerUid', '==', currentUser.uid),
      where('storeHandle', '==', subdomain),
      where('rewardId', '==', reward.id),
      where('status', '==', 'pending'),
      limit(1)
    );
    const pendingSnap = await getDocs(pendingClaimsQuery);
    if (!pendingSnap.empty) {
      throw new Error('You already have a pending claim for this reward.');
    }

    const pointsRef = doc(db, 'buyer_points', `${currentUser.uid}__${subdomain}`);

    await runTransaction(db, async (transaction) => {
      const pointsSnap = await transaction.get(pointsRef);
      const existingPointsData = pointsSnap.exists() ? pointsSnap.data() : { points: 0, totalEarned: 0, totalRedeemed: 0, transactions: [] };
      const currentBalance = Number(existingPointsData?.points || 0);

      if (currentBalance < pointsRequired) {
        throw new Error(`Need ${pointsRequired - currentBalance} more points.`);
      }

      const newTransactions = [...(existingPointsData.transactions || [])];
      newTransactions.push({
        type: 'deduct_on_request',
        amount: -pointsRequired,
        rewardTitle: reward.title || 'Custom Reward',
        rewardId: reward.id,
        date: new Date(),
      });

      transaction.set(pointsRef, {
        points: currentBalance - pointsRequired,
        totalEarned: Number(existingPointsData?.totalEarned || 0),
        totalRedeemed: Number(existingPointsData?.totalRedeemed || 0) + pointsRequired,
        transactions: newTransactions,
        lastRedeemedAt: serverTimestamp(),
      }, { merge: true });
    });

    const claimPayload = {
      buyerUid: currentUser.uid,
      buyerName: userData?.displayName || currentUser.displayName || '',
      buyerEmail: userData?.email || currentUser.email || '',
      rewardId: reward.id,
      rewardTitle: reward.title || 'Custom Reward',
      rewardType: reward.type || 'custom',
      rewardValue: Number(reward.value || 0),
      pointsCost: pointsRequired,
      pointsDeductedAtRequest: true,
      status: 'pending',
      storeHandle: subdomain,
      sellerUid: reward.sellerUid || storeConfig?.uid || '',
      createdAt: serverTimestamp(),
    };

    await addDoc(collection(db, 'reward_claim_requests'), claimPayload);
    await fetchBuyerPoints(currentUser.uid);
    return true;
  };

  const cancelCustomRewardClaim = async (claimDocId, rewardId) => {
    if (!currentUser) throw new Error('Please sign in to manage reward requests.');
    if (!claimDocId) throw new Error('Missing claim id.');

    const subdomain = getSubdomain();
    if (!subdomain) throw new Error('Store context missing. Please open a store URL.');

    const claimRef = doc(db, 'reward_claim_requests', claimDocId);
    const pointsRef = doc(db, 'buyer_points', `${currentUser.uid}__${subdomain}`);

    await runTransaction(db, async (transaction) => {
      const claimSnap = await transaction.get(claimRef);
      if (!claimSnap.exists()) throw new Error('Reward request not found.');

      const claimData = claimSnap.data() || {};
      if ((claimData.buyerUid || '') !== currentUser.uid) {
        throw new Error('You are not allowed to cancel this request.');
      }
      if ((claimData.storeHandle || '') !== subdomain) {
        throw new Error('Request does not belong to this store.');
      }

      const status = String(claimData.status || 'pending').toLowerCase();
      if (status !== 'pending') {
        throw new Error('Only pending requests can be cancelled.');
      }

      const pointsCost = Number(claimData.pointsCost || 0);
      const deductedAtRequest = Boolean(claimData.pointsDeductedAtRequest);
      const alreadyRefunded = Boolean(claimData.pointsRefundedOnReject);

      if (deductedAtRequest && pointsCost > 0 && !alreadyRefunded) {
        const pointsSnap = await transaction.get(pointsRef);
        const pointsData = pointsSnap.exists() ? (pointsSnap.data() || {}) : {};
        const currentBalance = Number(pointsData.points || 0);
        const totalRedeemed = Number(pointsData.totalRedeemed || 0);
        const transactions = Array.isArray(pointsData.transactions) ? [...pointsData.transactions] : [];

        transactions.push({
          type: 'refund_on_cancel',
          amount: pointsCost,
          rewardTitle: claimData.rewardTitle || 'Custom Reward',
          rewardId: rewardId || claimData.rewardId || '',
          date: new Date(),
        });

        transaction.set(pointsRef, {
          points: currentBalance + pointsCost,
          totalEarned: Number(pointsData.totalEarned || 0),
          totalRedeemed: Math.max(0, totalRedeemed - pointsCost),
          transactions,
          lastUpdatedAt: serverTimestamp(),
        }, { merge: true });
      }

      const claimUpdate = {
        status: 'cancelled',
        updatedAt: serverTimestamp(),
        updatedBy: currentUser.uid,
        cancelledAt: serverTimestamp(),
        cancelledBy: currentUser.uid,
      };
      if (deductedAtRequest && pointsCost > 0 && !alreadyRefunded) {
        claimUpdate.pointsRefundedOnReject = true;
        claimUpdate.pointsRefundedAt = serverTimestamp();
      }

      transaction.update(claimRef, claimUpdate);
    });

    await fetchBuyerPoints(currentUser.uid);
    return true;
  };

  const fetchCustomRewardClaimStatusMap = async () => {
    if (!currentUser) return {};
    const subdomain = getSubdomain();
    if (!subdomain) return {};

    const claimsQuery = query(
      collection(db, 'reward_claim_requests'),
      where('buyerUid', '==', currentUser.uid),
      where('storeHandle', '==', subdomain)
    );
    const snap = await getDocs(claimsQuery);
    const statusByRewardId = {};

    snap.docs.forEach((d) => {
      const data = d.data() || {};
      if (!data.rewardId) return;
      const createdAt = data.createdAt?.toMillis ? data.createdAt.toMillis() : 0;
      const existing = statusByRewardId[data.rewardId];
      const existingCreatedAt = existing?.createdAt || 0;
      if (existing && existingCreatedAt > createdAt) return;

      statusByRewardId[data.rewardId] = {
        status: data.status || 'pending',
        docId: d.id,
        createdAt,
      };
    });

    return statusByRewardId;
  };

  // --- 5. FETCH BUYER POINTS ---
  const fetchBuyerPoints = async (uid) => {
    const subdomain = getSubdomain();
    if (!subdomain || !uid) return;
    try {
      const pointsRef = doc(db, 'buyer_points', `${uid}__${subdomain}`);
      const pointsSnap = await getDoc(pointsRef);
      if (pointsSnap.exists()) {
        setBuyerPoints(pointsSnap.data());
      } else {
        setBuyerPoints({ points: 0, totalEarned: 0, totalRedeemed: 0, transactions: [] });
      }
    } catch (err) {
      console.error("Error fetching buyer points:", err);
      setBuyerPoints({ points: 0, totalEarned: 0, totalRedeemed: 0, transactions: [] });
    }
  };

  // --- 6. AUTH LISTENER ---
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (userAuth) => {
      if (userAuth) {
        setCurrentUser(userAuth);
        // Attempt to fetch profile
        const profile = await getUserProfile(userAuth.uid);
        setUserData(profile); // Will be null if new user
        // Fetch buyer points
        fetchBuyerPoints(userAuth.uid);
      } else {
        setCurrentUser(null);
        setUserData(null);
        setBuyerPoints(null);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    try {
      const subdomain = getSubdomain() || 'default';
      const uid = currentUser?.uid || 'guest';
      const rewardKey = `selected_redeem_reward_${subdomain}_${uid}`;
      const savedReward = localStorage.getItem(rewardKey);
      if (savedReward) {
        setSelectedRedeemReward(JSON.parse(savedReward));
      } else {
        setSelectedRedeemReward(null);
      }
    } catch (err) {
      console.error('Failed to load selected reward:', err);
      setSelectedRedeemReward(null);
    }
  }, [currentUser?.uid]);

  const value = {
    currentUser,
    userData,
    storeConfig,
    googleLogin,
    emailLogin,
    emailSignup,
    resetPassword,
    getUserProfile,
    saveUserProfile,
    updateUserProfile,
    signOut,
    buyerPoints,
    fetchBuyerPoints,
    selectedRedeemReward,
    selectRedeemReward,
    clearRedeemReward,
    createCustomRewardClaim,
    cancelCustomRewardClaim,
    fetchCustomRewardClaimStatusMap,
  };

  if (loading || !storeConfigLoaded) {
    return (
      <Center height="100vh">
        <Spinner size="xl" color="teal.500" />
      </Center>
    );
  }

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};